import { Role } from '../../types/permissions';

export const roleUtils = {
  // Encontrar rol por ID
  findRoleById: (roles: Role[], roleId: number): Role | undefined => {
    return roles.find(role => role.id === roleId);
  },

  // Verificar si es rol de administrador
  isAdminRole: (roleName: string): boolean => {
    return roleName.toLowerCase() === 'admin';
  },

  // Obtener roles que se pueden eliminar
  getDeletableRoles: (roles: Role[]): Role[] => {
    return roles.filter(role => !roleUtils.isAdminRole(role.name));
  },

  // Limpiar formulario de rol
  clearRoleForm: () => ({
    name: '',
    description: ''
  })
};
